import React from 'react';
import LegalDocumentModal from 'components/LegalDocumentModal/LegalDocumentModal';

export default function Tos() {
    return (
        <LegalDocumentModal
            kind="tos"
            titleKey="tos"
        />
    );
}
